/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileExcel32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none">
            <path
                fill="#107C41"
                d="M9 3h9.586c.265 0 .52.105.707.293l6.415 6.414a1 1 0 01.293.707V26A3.002 3.002 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            />
            <path
                fill="#87BDA0"
                d="M19.286 3.286l6.422 6.421a.994.994 0 01.203.293H21a2.001 2.001 0 01-1.995-1.85L19 8V3.09c.105.048.202.114.286.196z"
            />
            <path
                fill={vars.white}
                d="M20.25 25a.748.748 0 00.75-.75v-10.5a.748.748 0 00-.75-.75H12a.748.748 0 00-.75.75v1.5h-1.5A.748.748 0 009 16v6a.748.748 0 00.75.75h1.5v1.5A.748.748 0 0012 25h8.25zm-4.5-9.75H12v-1.5h3.75v1.5zm4.5 0H16.5v-1.5h3.75v1.5zm0 3H16.5V16h3.75v2.25zm-8.344 3.188h-1.511l1.582-2.45-1.442-2.425h1.518l.756 1.494.82-1.494h1.43l-1.483 2.42 1.518 2.454H13.6l-.838-1.564-.856 1.564zm8.344-.188H16.5V19h3.75v2.25zm0 3H16.5V22h3.75v2.25zm-4.5 0H12v-1.5h3.75v1.5z"
            />
        </g>
    </AccessibleSVG>
);

export default FileExcel32;
